export const articles = [
  {
    slug: 'dingliu-nanyixing-yehuisixheng-baoliao',
    title: '顶流男艺人夜会神秘女子？知情人爆料细节令人震惊',
    excerpt: '据知情人士透露，某当红顶流男星近日深夜现身某高档酒店，被拍到与一名神秘女子同行，两人举止亲密，疑似恋情曝光。该消息一出立即引发网友热议，粉丝纷纷要求工作室给出回应。',
    content: `<p>近日，一则关于某顶流男艺人的爆料在网络上迅速发酵。据多位知情人士透露，该艺人于本月初深夜独自前往北京某五星级酒店，与一名身份不明的年轻女子共处数小时。</p>
    <p>据悉，该艺人近期正处于事业上升期，多部作品即将上映。其工作室对于此事尚未作出任何回应，但已经在社交平台上删除了一些粉丝的评论。</p>
    <p>有圈内人士分析称，该男星一直以来都是以单身人设示人，若恋情属实，将对其商业价值产生一定影响。不过也有不少网友表示支持艺人正常恋爱，认为私生活不该被过度关注。</p>
    <p>截至目前，该事件仍在持续发酵中，相关话题阅读量已突破5亿。我们将持续关注此事的最新进展。</p>`,
    category: 'mingxing',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stylish%20male%20celebrity%20walking%20at%20night%20in%20front%20of%20a%20luxury%20hotel%20with%20paparazzi%20vibe%2C%20cinematic%20lighting%2C%20dramatic%20mood%2C%20warm%20golden%20and%20dark%20tones%2C%20editorial%20photography%2C%20high%20contrast%2C%20mysterious%20atmosphere%2C%20soft%20bokeh%20background&width=800&height=450&seq=article-cover-01&orientation=landscape',
    publishedAt: '2026-08-07',
    views: 128500,
    tags: ['顶流', '男艺人', '恋情', '爆料'],
  },
  {
    slug: 'wanghong-daihuo-fanche-shijian',
    title: '千万粉丝网红直播带货翻车？产品质量遭消费者集体投诉',
    excerpt: '拥有超过两千万粉丝的知名网红近日在直播带货中遭遇重大翻车事件，其推荐的多款产品被消费者反映存在严重质量问题，引发大规模投诉和退款潮。',
    content: `<p>近日，一位拥有超过2000万粉丝的头部网红因直播带货产品质量问题，陷入了前所未有的信任危机。据悉，该网红在上周的直播中推荐了多款美妆和日用品，然而大量消费者收到货后纷纷表示产品与宣传严重不符。</p>
    <p>据报道，已有超过3000名消费者在各大平台发起投诉，涉及的产品包括面膜、精华液等多个品类。部分消费者反映使用后出现过敏、红肿等不良反应。</p>
    <p>该网红最初在直播间回应称"产品均有正规资质"，但随着投诉持续增加，最终在社交媒体发布道歉声明，承诺对问题订单进行全额退款。</p>
    <p>业内人士分析称，此次事件再次暴露了直播带货行业在产品质量把控方面的漏洞，相关监管部门或将对直播带货行业进行更加严格的规范管理。</p>`,
    category: 'wanghong',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20female%20livestreamer%20sitting%20in%20front%20of%20a%20ring%20light%20with%20products%20on%20a%20desk%2C%20worried%20expression%2C%20warm%20studio%20lighting%2C%20modern%20apartment%20background%2C%20editorial%20style%2C%20soft%20shadows%2C%20clean%20composition&width=800&height=450&seq=article-cover-02&orientation=landscape',
    publishedAt: '2026-08-06',
    views: 95600,
    tags: ['网红', '直播带货', '翻车', '消费者投诉'],
  },
  {
    slug: 'nvxing-xinju-shouji-baohong',
    title: '85花新剧收视率爆表！演技获得观众一致好评',
    excerpt: '某85花旦主演的古装大剧首播收视率破3，创下今年电视剧首播最高纪录。观众纷纷称赞其演技进步明显，剧情紧凑引人入胜，有望成为年度爆款。',
    content: `<p>由知名85花旦主演的古装大剧于昨晚正式开播，首播收视率高达3.2%，不仅打破了今年电视剧首播纪录，更是在各大社交平台掀起了一股追剧热潮。</p>
    <p>该剧改编自热门网络小说，讲述了女主角从平民到一代女官的传奇人生。女主角的扮演者凭借精湛的演技，将角色的成长与蜕变演绎得淋漓尽致，获得了观众和业内人士的一致认可。</p>
    <p>有影评人表示，该85花旦此次的表现堪称其演艺生涯的代表作，无论是眼神戏还是台词功底都有了质的飞跃。同时剧中的服化道也相当考究，场景宏大精美。</p>
    <p>目前该剧在各大评分平台的评分均在8.5分以上，口碑持续走高。业内人士预测，该剧极有可能成为今年的年度爆款。</p>`,
    category: 'mingxing',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20actress%20in%20ancient%20costume%20drama%20setting%2C%20elegant%20hanfu%20dress%2C%20soft%20diffused%20lighting%2C%20cinematic%20atmosphere%2C%20palace%20background%20with%20red%20lanterns%2C%20ethereal%20and%20dreamy%20mood%2C%20editorial%20photography&width=800&height=450&seq=article-cover-03&orientation=landscape',
    publishedAt: '2026-08-05',
    views: 78200,
    tags: ['85花', '新剧', '收视率', '演技'],
  },
  {
    slug: 'yinyuejie-dingji-gehou-chugui-chouwen',
    title: '乐坛顶级歌后疑似婚变？老公被拍到与女助理亲密同行',
    excerpt: '歌坛天后级歌手的婚姻状况近日引发关注。其丈夫被狗仔拍到深夜与女助理一同出入私人会所，两人举止亲密疑似关系不寻常，网友扒出更多细节。',
    content: `<p>近日，歌坛天后级歌手L的婚姻状况成为了大众关注的焦点。据某知名娱记爆料，L的丈夫被拍到深夜与一名年轻女助理一同出入某私人会所，两人停留约三小时后才离开，期间举止亲密。</p>
    <p>消息一出，立刻在网络上引发轩然大波。有网友迅速扒出该女助理的社交账号，发现其经常在深夜发布暧昧动态，且时间线与L在外地演出高度重合。</p>
    <p>目前L本人尚未对此事作出回应，但其社交平台近期的动态已经被网友解读出多种暗示。有接近L的人士透露，两人其实早已分居，只是一直未对外公布。</p>
    <p>该事件引发了对明星婚姻的广泛讨论，不少网友感叹娱乐圈的婚姻似乎总是难以长久，也有人呼吁尊重艺人隐私，不应对私人生活过度猜测。</p>`,
    category: 'bagua',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20glamorous%20female%20singer%20on%20stage%20with%20microphone%2C%20spotlight%20illuminating%20her%2C%20emotional%20performance%2C%20dark%20concert%20background%2C%20dramatic%20stage%20lighting%2C%20professional%20photography%2C%20warm%20gold%20and%20purple%20tones%2C%20atmospheric&width=800&height=450&seq=article-cover-04&orientation=landscape',
    publishedAt: '2026-08-04',
    views: 112300,
    tags: ['天后', '婚变', '出轨', '爆料'],
  },
  {
    slug: 'wanghong-beibaoyang-neimu-jiepi',
    title: '网红圈惊天内幕！多名头部网红被曝与富豪有不正当关系',
    excerpt: '一份神秘名单近日在社交平台疯传，涉及多位拥有百万粉丝的网红被指与多名富豪存在不正当关系。该名单引发网友疯狂讨论，部分涉事网红已紧急删帖。',
    content: `<p>近日，一份在社交平台疯传的"神秘名单"将网红圈推向了舆论的风口浪尖。该名单详细列明了数十位拥有百万级粉丝的网红与多名富豪之间存在不正当关系的相关信息。</p>
    <p>名单中不仅包含了网红的社交账号、真实姓名等个人信息，还附带了大量的聊天记录截图和转账记录作为佐证。目前已有超过5位涉事网红紧急清理了自己的社交账号内容。</p>
    <p>此事迅速引发了社会各界的广泛关注。有媒体试图联系名单中涉及的各方人士，但大多数人都选择了回避。法律界人士指出，如果名单中的内容属实，其中部分行为可能涉嫌违法。</p>
    <p>与此同时，也有声音质疑该名单的真实性，认为可能存在恶意造谣的成分。多个平台已经对相关不实信息进行了清理，并呼吁网友理性看待网络传言。</p>`,
    category: 'wanghong',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20luxurious%20mansion%20interior%20with%20a%20fashionable%20young%20woman%20taking%20selfie%20with%20phone%2C%20high-end%20decor%2C%20chandelier%2C%20marble%20floors%2C%20glamorous%20lifestyle%20aesthetic%2C%20warm%20golden%20lighting%2C%20editorial%20photography&width=800&height=450&seq=article-cover-05&orientation=landscape',
    publishedAt: '2026-08-03',
    views: 189400,
    tags: ['网红', '内幕', '富豪', '爆料'],
  },
  {
    slug: 'yulequan-xiao-xianrou-zhengrong-zhibo',
    title: '某小鲜肉整容前后对比照曝光！网友直呼认不出',
    excerpt: '一组据称是某当红小鲜肉出道前后的对比照片在网络上疯传，面部变化之大令人咋舌。网友纷纷留言表示"完全判若两人"，该艺人工作室尚未回应。',
    content: `<p>一组据称是某当红小鲜肉出道前后的对比照片今日在网络上引起轩然大波。照片中人物的面部轮廓、鼻梁高度、下巴线条等均有显著变化，让人难以相信这是同一个人。</p>
    <p>该组照片据称来自其高中同学，拍摄时间距今不过四五年。对比其现在的官方宣传照，确实存在肉眼可见的巨大差异。有整形医生通过对比分析后表示，该艺人很可能进行了鼻部、下颌角以及眼部多项整形手术。</p>
    <p>此事一经曝光，立刻在粉丝圈内引发激烈争论。一部分粉丝力挺偶像，称"颜值即正义"；另一部分则表示失望，认为艺人应该对自己的粉丝诚实。</p>
    <p>截至目前，该艺人的工作室尚未对此事作出回应。但据知情人士透露，工作室内部已经在紧急商讨应对方案，不排除通过法律手段维护艺人形象的可能。</p>`,
    category: 'shenba',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20handsome%20male%20celebrity%20with%20perfect%20skin%20posing%20for%20a%20magazine%20cover%2C%20studio%20lighting%2C%20high%20fashion%20editorial%20style%2C%20clean%20white%20background%2C%20flawless%20makeup%2C%20professional%20photography&width=800&height=450&seq=article-cover-06&orientation=landscape',
    publishedAt: '2026-08-02',
    views: 145700,
    tags: ['小鲜肉', '整容', '对比照', '爆料'],
  },
  {
    slug: 'zongyi-jiemu-neiding-guanjun-zhengyi',
    title: '热门选秀节目被爆内定冠军？选手发长文控诉节目组黑幕',
    excerpt: '刚刚落幕的某大型选秀节目被参赛选手爆出存在严重黑幕。一位未能进入决赛的选手昨日发布长文，详细揭露了节目组在比赛过程中的种种不公操作。',
    content: `<p>刚刚落下帷幕的某大型选秀节目陷入了"内定"风波。昨日，一位在节目中未能进入决赛的选手发布了一篇超过万字的长文，详细揭露了节目组在比赛过程中的种种不公平操作。</p>
    <p>该选手在长文中指出，节目组从海选阶段就开始对特定选手进行"力捧"，不仅给予了更多的镜头和表演机会，甚至在投票环节也进行了人为干预。文中还附带了多张聊天记录截图作为证据。</p>
    <p>此事迅速在网络上引发热议，话题阅读量短时间内突破10亿。不少网友表示"早就感觉不对劲了"，并呼吁有关部门对此进行调查。而该节目的官方账号目前仍未作出回应。</p>
    <p>业内人士分析称，选秀节目的"剧本化"问题由来已久，但如此详细的内部爆料实属罕见。如果该选手所言属实，节目制作方可能面临严重的信用危机和法律风险。</p>`,
    category: 'zuixin',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20large%20stage%20with%20spotlights%20and%20colorful%20LED%20screens%20showing%20a%20talent%20show%20competition%2C%20dramatic%20stage%20lighting%2C%20audience%20silhouettes%2C%20grand%20production%20atmosphere%2C%20cinematic%20photography&width=800&height=450&seq=article-cover-07&orientation=landscape',
    publishedAt: '2026-08-01',
    views: 201500,
    tags: ['选秀', '内定', '黑幕', '维权'],
  },
  {
    slug: 'yingshi-quan-shuiwu-diaocha-fengbo',
    title: '娱乐圈税务风暴再起！多名艺人被约谈补缴税款',
    excerpt: '继此前多位明星因税务问题被查处后，娱乐圈再次掀起税务调查风暴。据悉已有超过20位艺人被税务部门约谈，涉及金额高达数亿元。',
    content: `<p>娱乐圈的税务风暴再度来袭。据可靠消息称，税务部门近期对娱乐圈开展了一轮新的专项税务调查，已有超过20位知名艺人被约谈，涉及补缴税款及滞纳金总金额高达数亿元人民币。</p>
    <p>据悉，此次调查的重点主要集中在艺人通过"阴阳合同"、个人工作室等途径规避个人所得税的行为。部分艺人已经主动配合补缴税款，但也有个别艺人试图通过各种方式逃避调查。</p>
    <p>娱乐圈税务问题一直以来都是敏感话题。自此前某知名女星因税务问题被重罚后，整个行业曾经集体进行了自查自纠。然而此次新一轮调查似乎表明，行业内的问题并未得到根本解决。</p>
    <p>法律专家指出，依法纳税是每个公民的义务，明星艺人作为高收入群体更应该以身作则。此次税务风暴或将推动娱乐圈建立更加规范的财税管理体系。</p>`,
    category: 'zuixin',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20serious%20business%20scene%20with%20documents%20and%20calculator%20on%20a%20dark%20wooden%20desk%2C%20dramatic%20lighting%20from%20window%2C%20corporate%20and%20tense%20atmosphere%2C%20editorial%20photography%2C%20warm%20amber%20and%20shadow%20tones&width=800&height=450&seq=article-cover-08&orientation=landscape',
    publishedAt: '2026-07-31',
    views: 167800,
    tags: ['税务', '艺人', '补税', '调查'],
  },
  {
    slug: 'wanghong-canyin-dian-zhibo-baizhi',
    title: '网红餐饮店直播后厨被曝脏乱差！食客当场呕吐送医',
    excerpt: '一家由知名网红创办的餐饮连锁店近日被暗访记者拍到后厨卫生状况极其恶劣，更有食客在用餐后当场呕吐被送往医院。该网红已紧急关闭所有门店。',
    content: `<p>由某千万粉丝美食网红创办的餐饮连锁品牌近日遭遇了前所未有的信任危机。一位暗访记者以兼职员工身份卧底其旗舰店后厨，拍摄到的画面令人触目惊心。</p>
    <p>画面显示，后厨食材随意堆放，过期食材仍在继续使用，员工在操作过程中完全没有任何卫生防护措施。更令人震惊的是，记者还拍到了老鼠在后厨出没的画面。就在暗访期间，一位顾客在店内用餐后当场呕吐不止，被紧急送往医院。</p>
    <p>视频曝光后，该网红第一时间发布道歉声明，并表示将关闭所有门店进行全面整改。然而消费者并不买账，纷纷表示"再也不去了"。目前当地市场监管部门已经介入调查。</p>
    <p>此事件再次引发了社会对网红餐饮品牌的广泛讨论。业内人士指出，很多网红餐饮过度追求流量和扩张速度，忽视了最基本的食品安全，消费者的权益难以得到保障。</p>`,
    category: 'wanghong',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20messy%20restaurant%20kitchen%20with%20dim%20lighting%2C%20dirty%20surfaces%2C%20scattered%20ingredients%2C%20unhygienic%20conditions%2C%20documentary%20style%20photography%2C%20harsh%20fluorescent%20light%2C%20realistic%20and%20gritty%20atmosphere&width=800&height=450&seq=article-cover-09&orientation=landscape',
    publishedAt: '2026-07-30',
    views: 234600,
    tags: ['网红', '餐饮', '卫生', '曝光'],
  },
  {
    slug: 'mingxing-gaokao-zuobi-zhengyi',
    title: '明星学霸人设崩塌？高考成绩疑被扒出与宣传不符',
    excerpt: '一位以"学霸"人设走红的年轻艺人近日被网友扒出其真实高考成绩与团队宣传的相差甚远，引发对其人设真实性的广泛质疑。',
    content: `<p>娱乐圈又一位"学霸人设"面临崩塌危机。一位近两年以"学霸"标签走红的年轻艺人，近日被网友扒出其真实高考成绩与团队对外宣传的数据存在明显出入。</p>
    <p>据网友爆料，该艺人团队此前一直对外宣传其高考成绩为650+分，并在多个综艺节目中大谈自己的学习经验和方法。然而有网友通过学籍系统查询发现，其实际高考成绩仅为400余分，与宣传相差超过200分。</p>
    <p>此事曝光后，该艺人的粉丝群体内部出现了明显分裂。一部分粉丝坚持认为"成绩不重要"，但更多的网友表示受到了欺骗，认为这种虚假宣传是对真正努力学习的学生的侮辱。</p>
    <p>目前该艺人及其团队尚未对此事作出回应。但已经有多个品牌方暂停了与该艺人的合作，可见此次人设崩塌对其商业价值已经造成了实质性的影响。</p>`,
    category: 'shenba',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20student%20sitting%20at%20a%20desk%20in%20a%20classroom%20with%20exam%20papers%2C%20worried%20and%20stressed%20expression%2C%20natural%20window%20light%2C%20soft%20and%20melancholic%20atmosphere%2C%20editorial%20style%20photography&width=800&height=450&seq=article-cover-10&orientation=landscape',
    publishedAt: '2026-07-29',
    views: 89100,
    tags: ['学霸', '人设崩塌', '高考', '造假'],
  },
  {
    slug: 'zhuming-diepian-zhi-zhubo-beibu',
    title: '知名游戏主播因涉嫌赌博被警方带走！直播中突然中断',
    excerpt: '某知名游戏主播在直播过程中突然被警方带走，直播间瞬间炸锅。事后证实该主播涉嫌组织网络赌博活动，涉案金额高达数千万元。',
    content: `<p>一场突如其来的抓捕行动在直播中真实上演。某头部游戏直播平台的主播在正常直播游戏时，画面中突然出现多名执法人员，主播随即被带走，直播画面就此中断。</p>
    <p>据了解，该主播拥有超过500万粉丝，在游戏直播圈内有着极高的知名度。经警方后续通报确认，该主播涉嫌利用直播平台组织网络赌博活动，涉案金额高达数千万元人民币。</p>
    <p>直播间内的数万名观众亲眼目睹了这一幕，弹幕瞬间爆炸。大量粉丝在震惊之余纷纷表示"不敢相信"，也有网友指出该主播此前就曾多次在直播中暗示赌博相关信息。</p>
    <p>此事在直播行业内引发了强烈震动。多个直播平台随即宣布将加强对主播行为的监管力度，杜绝类似事件再次发生。法律专家提醒，网络赌博属于严重违法行为，切勿心存侥幸。</p>`,
    category: 'zuixin',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20gaming%20streamer%20setup%20with%20multiple%20monitors%20and%20RGB%20lighting%2C%20gaming%20chair%20empty%2C%20tense%20and%20abandoned%20atmosphere%2C%20dark%20room%20with%20neon%20lights%2C%20cinematic%20photography%2C%20dramatic%20mood&width=800&height=450&seq=article-cover-11&orientation=landscape',
    publishedAt: '2026-07-28',
    views: 312000,
    tags: ['主播', '赌博', '抓捕', '直播'],
  },
  {
    slug: 'nv-mingxing-hongtan-zaoxing-bei-piping',
    title: '女星红毯造型被群嘲！网友：这是得罪造型师了吗？',
    excerpt: '某知名女星在最新红毯活动上的造型引发全网群嘲。有网友调侃称"这大概是被造型师坑得最惨的一次"，话题迅速登上热搜榜首。',
    content: `<p>昨日举办的某时尚盛典红毯环节可谓看点十足，但最受关注的并非哪位明星造型最佳，而是一位知名女星令人大跌眼镜的"灾难级"红毯造型。</p>
    <p>该女星身着一套据称价值不菲的高级定制礼服亮相红毯，然而这套造型却遭到了网友的一致差评。过于夸张的肩部设计、不协调的色彩搭配以及完全不搭的妆容，被网友戏称为"红毯年度最惨造型"。</p>
    <p>话题"某某红毯造型"迅速登上热搜榜首，阅读量短时间内突破8亿。大量网友在评论区留言调侃，各种"表情包"和"Meme"层出不穷。不过也有粉丝为偶像辩护，认为时尚本就多元，不应以单一标准评判。</p>
    <p>有资深时尚评论人分析称，此次造型翻车的原因可能是造型团队与艺人之间的沟通出现了问题。在红毯这样重要的场合，一个合适的造型团队至关重要。</p>`,
    category: 'bagua',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20female%20celebrity%20on%20a%20red%20carpet%20wearing%20an%20extravagant%20but%20questionable%20fashion%20outfit%2C%20paparazzi%20flash%20photography%2C%20glamorous%20event%20setting%2C%20dramatic%20lighting%2C%20editorial%20style%2C%20high%20contrast%2C%20fashion%20event%20atmosphere&width=800&height=450&seq=article-cover-12&orientation=landscape',
    publishedAt: '2026-07-27',
    views: 98900,
    tags: ['红毯', '造型翻车', '热搜', '娱乐'],
  },
];

export const popularArticles = [
  {
    slug: 'wanghong-canyin-dian-zhibo-baizhi',
    title: '网红餐饮店直播后厨被曝脏乱差！食客当场呕吐送医',
    views: 234600,
  },
  {
    slug: 'zhuming-diepian-zhi-zhubo-beibu',
    title: '知名游戏主播因涉嫌赌博被警方带走！',
    views: 312000,
  },
  {
    slug: 'zongyi-jiemu-neiding-guanjun-zhengyi',
    title: '热门选秀节目被爆内定冠军？选手发长文控诉',
    views: 201500,
  },
  {
    slug: 'wanghong-beibaoyang-neimu-jiepi',
    title: '网红圈惊天内幕！多名头部网红被曝与富豪有关系',
    views: 189400,
  },
  {
    slug: 'yingshi-quan-shuiwu-diaocha-fengbo',
    title: '娱乐圈税务风暴再起！多名艺人被约谈',
    views: 167800,
  },
  {
    slug: 'mingxing-gaokao-zuobi-zhengyi',
    title: '明星学霸人设崩塌？高考成绩疑被扒出',
    views: 89100,
  },
];